// Libs
import React from 'react'

// CSS
import './styles.scss'

// Normalize
import { normalize } from '../../constants'

const DashboardBox = ({ style, type, title, percentage, children }) => {
  let data = ''

  if (children) {
    data = children
  } else if (children === 0) {
    data = 0
  } else if (children > 99999) {
    data = '99999+'
  }

  data = normalize(type, data)

  return (
    <div className={style === 'white' ? 'dashboard-box dashboard-box--white' : 'dashboard-box'}>
      <p className="dashboard-box__title">{title}</p>
      <p className="dashboard-box__data">{data}</p>
    </div>
  )
}

export default DashboardBox
